import type { BuyerInventoryQueryParams } from '~/api';
import type { BuyerInventoryFiltersInput } from '~/graphql/graphql';

export function revealProbeParams(
  viewFilters: BuyerInventoryFiltersInput | undefined
): BuyerInventoryQueryParams | undefined {
  return viewFilters ? { filters: viewFilters } : undefined;
}

export function isAllHiddenByLengthFilter(input: {
  includeInventoryLengths: boolean;
  isLoading: boolean;
  visibleCount: number;
  totalIncludingHidden: number;
}): boolean {
  return (
    !input.includeInventoryLengths &&
    !input.isLoading &&
    input.visibleCount === 0 &&
    input.totalIncludingHidden > 0
  );
}
